import { withViewComponent } from '@updater-legacy/components/custom-element';
import '@updater-components/currency-formatter';
import '@updater-components/tooltip';
import '../chip';
import '../expandable-container';
import { when } from '../../../promotions/app/utils';
import styles from './index.css';

class OfferCard extends withViewComponent(styles)() {
  static props = ['offer'];

  constructor() {
    super();
    this.media = window.matchMedia('(max-width: 470px)');
    this.handleMedia(this.media);
  }

  connected() {
    this.media.addListener(this.handleMedia);
  }

  disconnected() {
    this.media.removeListener(this.handleMedia);
  }

  handleMedia = (media) => {
    if (media.matches) {
      this.mergeState({ tooltipSide: 'left' });
    } else {
      this.mergeState({ tooltipSide: 'right' });
    }
  };

  // prettier-ignore
  renderFeatures(features) {
    return this.wire('features')`
    <div>
      ${features.map((f) => this.wire(f)`<div class="feature">${f}</div>`)}
    </div>
    `;
  }

  renderExtraFeatures(features) {
    return this.wire('extraFeatures')`
    <div>
      ${features.map(
        (f) => this.wire(f)`<div class="extra-features">${f}</div>`
      )}
    </div>
    `;
  }

  updated({ offer, _state: { tooltipSide } }) {
    this.render`
      <div class="price">
        <upd-currency-formatter
          class="monthly"
          value=${offer.price}>
        </upd-currency-formatter>
        /month + 
        <upd-currency-formatter
          class="install"
          value=${offer.installPrice}>
        </upd-currency-formatter>
        Install
      </div>
      <upd-tooltip
        enabled
        width="200"
        position=${tooltipSide}
        label="${offer.tooltip}"
      >
        <upd-fa-icon name="question-circle" type="solid"></upd-fa-icon>
      </upd-tooltip>
      <div class="features">
        <strong>${offer.featureHeader}</strong>
        ${this.renderFeatures(offer.features)}
      </div>
      ${when(
        offer.extraFeatures,
        () => this.wire()`
          <upd-features-expandable-container>
            <span slot="title">See More</span>
            <div class="extra-container">
              <strong>${offer.extraFeatureHeader}</strong>
              ${this.renderExtraFeatures(offer.extraFeatures)}
            </div>
          </upd-features-expandable-container>`
      )}
    `;
  }
}

customElements.define('upd-home-security-offer-card', OfferCard);
